<div class="card card-custom p-3">
    <!-- Top Section -->
    <div class="row mb-2">
        <div class="col-md-8 mb-3">
            <label class="form-label fw-semibold text-muted">Salary Head</label>
            <div class="fs-6 fw-bold text-dark border rounded px-2 py-1 bg-light">
                {{this.SalaryHeadCode}} - {{this.SalaryHeadNamee}}
            </div>
        </div>

        <div class="col-md-4 mb-3">
            <label class="form-label fw-semibold text-muted">Percentage (%)</label>
            <div class="fs-6 fw-bold text-dark border rounded px-2 py-1 bg-light">
                {{this.Percentage}} %
            </div>
        </div>
    </div>

    <div class="row mb-2">
        <div class="col"></div>
        <div class="col-md-4">
            <div class="input-group">
                <span class="input-group-text" id="basic-addon2">🔍</span>
                <input type="text" id="tableSearch" name="tableSearch"  (keyup)="SearchInTable($event)" class="form-control" placeholder="Search head...">
            </div>

        </div>
    </div>

    <!-- Table -->
    <div class="table-responsive table-scroll">
        <table class="table table-hover align-middle mb-0">
            <thead class="table-light">
                <tr>
                    <th style="width:120px;">Code</th>
                    <th>Salary Head</th>
                    <th class="text-center" style="width:120px;"><input class="form-check-input" type="checkbox"
                            id="IsCheckAll" name="IsCheckAll" (click)="Check($event,0,true)"> Add</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let element of Formulas; let i = index">
                    <td>{{element.SalaryHeadCode}}</td>
                    <td>{{element.SalaryHeadName}}</td>
                    <td class="text-center">
                        <input class="form-check-input" type="checkbox" id="IsCheck{{i}}" name="IsCheck{{i}}"
                            (click)="Check($event,i)" [disabled]="element.isDisabled" [(ngModel)]="element.IsCheck">
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Selected Summary -->
    <div class="footer-box mb-4">
        <strong>Selected:</strong> {{this.ReturnFormula}}
    </div>

    <!-- Buttons -->
    <div class="d-flex justify-content-end gap-2">
        <button class="btn btn-outline-danger px-4" type="button" (click)="close()">
            <i class="bi bi-x"></i> Cancel
        </button>
        <button class="btn btn-success px-4" type="button" (click)="Ok()">
            <i class="bi bi-check2"></i> OK
        </button>        
    </div>

</div>